const BUY_PROPERTY_TYPES = {
    FIRST:  '首套房',
    SECOND: '二套房',
    THIRD: '三套房'
}
const ELEVATOR_TYPES = {
    YES: '电梯住宅',
    NO: '非电梯住宅'
}
const TRANSFER_YEAR_COLLECTION = {
    STAGEONE: '5年以内',
    STAGETHREE: '5年及以上'
}
const IS_ONLY_HOUSE = {
    TRUE: '是',
    FALSE: '否'
}
export const TRANSFER_YEAR = [
    TRANSFER_YEAR_COLLECTION.STAGEONE,
    TRANSFER_YEAR_COLLECTION.STAGETHREE
]
export const ONLY_HOUSE = [
    IS_ONLY_HOUSE.TRUE,
    IS_ONLY_HOUSE.FALSE
]
export const BUY_PROPERTY = [
    BUY_PROPERTY_TYPES.FIRST,
    BUY_PROPERTY_TYPES.SECOND,
    BUY_PROPERTY_TYPES.THIRD
]
export const ELEVATOR_TYPE =[
    ELEVATOR_TYPES.YES,
    ELEVATOR_TYPES.NO
]
export const LOCATION = [
    { loc: '高新南区', value: 1100},
    { loc: '高新西区', value: 1100},
    { loc: '高新东区', value: 1100},
    { loc:'天府新区成都直管区', value: 1100},
    { loc: '青羊区', value: 1100},
    { loc: '金牛区', value: 1100},
    { loc: '武侯区', value: 1100},
    { loc: '成华区', value: 1100},
    { loc: '锦江区', value: 1100},
    { loc: '龙泉驿区', value: 1100},
    { loc: '青白江区', value: 1100},
    { loc: '新都区', value: 1100},
    { loc: '温江区', value: 1100},
    { loc: '双流区', value: 1100},
    { loc: '郫都区', value: 1100},
    { loc: '都江堰市', value: 720},
    { loc: '简阳市', value: 720},
    { loc: '崇州市', value: 600},
    { loc: '彭州市', value: 550},
    { loc: '大邑县', value: 550},
    { loc: '金堂县', value: 550},
    { loc: '蒲江县', value: 550},
    { loc: '邛崃市', value: 500},
    { loc: '新津区', value: 500}
]
export const calcNewHouse = (params) => {
    const {
        type,
        unit_price,
        area,
        buy_property,
        elevator_type,
        location
    } = params
    let all_price = (unit_price * area).toFixed(2)
    const deep_tax = getDeedTax(buy_property, area, all_price)
    const maintenance_fund = getMaintenanceFund(location, area, elevator_type)
    const all_taxes = (Number(deep_tax) + Number(maintenance_fund) + 85).toFixed(2)
    all_price = (all_price/10000).toFixed(2)
    return {
        type,
        all_price,
        all_taxes,
        unit_price,
        area,
        detail: {
            '契税': deep_tax,
            '住宅专项维修基金': maintenance_fund,
            '权属登记费': '80.00',
            '合同工本费': '5.00',
        },
        selected_detail: [
            {
                label: '购房性质',
                value: buy_property
            },
            {
                label: '所在区域',
                value: location.loc
            },
            {
                label: '有无电梯',
                value: elevator_type
            },
            {
                label: '房屋面积',
                value: area + '㎡'
            },
            {
                label: '房屋单价',
                value: unit_price + '元/㎡'
            },
        ],
        style: 'new'
    }
}
/**
 * 计算契税
 * @param {购房性质} type
 * @param {房屋面积} area
 * @param {房屋总结} all_parice
 */
const getDeedTax = (type, area, all_parice) => {
    if ( type ===  BUY_PROPERTY_TYPES.THIRD ) {
        return (all_parice * 0.03).toFixed(2)
    }
    if ( area <= 90) {
        return (all_parice * 0.01).toFixed(2)
    }
    return type === BUY_PROPERTY_TYPES.FIRST ? (all_parice * 0.015).toFixed(2) : (all_parice * 0.02).toFixed(2)
}
/**
 * 住宅专项维修基金
 * @param {所在区域} location
 * @param {房屋面积} area
 * @param {有无电梯} elevator_type
 */
const getMaintenanceFund = (location, area, elevator_type) => {
    const coefficient = {
        [ELEVATOR_TYPES.YES]: 0.025,
        [ELEVATOR_TYPES.NO]: 0.02
    }
    let cost = 0;
    for(var i=0;i<LOCATION.length;i++){
        if (LOCATION[i].loc === location.loc) {
            cost =  LOCATION[i].value
        }
    }
    return (cost * coefficient[elevator_type] * area).toFixed(2)
}
export const calcOldHouse = (params) => {
    const {
        type,
        all_price,
        area,
        transfer_year,
        buy_property,
        only_house
    } = params
    const price = all_price * 10000
    const unit_price = Number(( price / area).toFixed(2))
    const deep_tax = getDeedTax(buy_property, area, price)
    const VAT = getVAT(transfer_year, price)
    const income_taxes = getIncomeTaxes(transfer_year, price, only_house)
    const all_taxes = (Number(deep_tax) + Number(VAT) + Number(income_taxes) + 80).toFixed(2)
    return {
        type,
        all_price,
        all_taxes,
        unit_price,
        area,
        detail: {
            '契税': deep_tax,
            '个税': income_taxes,
            '增值税': VAT,
            '转移登记费': '80.00',
        },
        selected_detail: [
            {
                label: '购房性质',
                value: buy_property
            },
            {
                label: '房屋面积',
                value: area + '㎡'
            },
            {
                label: '房屋总价',
                value: all_price + '万'
            },
            {
                label: '转让年限',
                value: transfer_year
            },
            {
                label: '是否卖家唯一住房',
                value: only_house
            },
        ],
        style: 'old'
    }
}
/**
 * 增值税
 * @param {转让年限} transfer_year
 * @param {房屋总价} all_price
 */
const getVAT = (transfer_year, all_price) => {
    return transfer_year === TRANSFER_YEAR_COLLECTION.STAGEONE
        ? (all_price * 0.05).toFixed(2)
        : '0.00'
}
/**
 * 个税
 * @param {转让年限} transfer_year
 * @param {房屋总价} all_price
 * @param {是否唯一住房} only_house
 */
const getIncomeTaxes = (transfer_year, all_price, only_house) => {
    return transfer_year === TRANSFER_YEAR_COLLECTION.STAGETHREE && only_house === IS_ONLY_HOUSE.TRUE
        ? '0.00'
        : (all_price * 0.01).toFixed(2)
}
export const checkSubmit = (params, rules) => {
    return Object.keys(rules).every((key) => {
        const { required, text } = rules[key]
        const value = params[key]
        if (required && ! Number(value)) {
            wx.showToast({
                title: `请填写${text}`,
                icon: 'none'
            })
            return false
        }
        return true
    })
}
export const formatNumberInput = (e) => {
    const { value } = e.target
    const num = Number(value)
    if (!num || isNaN(num)) {
        return ''
    }
    return num.toFixed(2);
}

